<template>
  <v-sheet color="white" class="activePosition">
    <!-- Stepper -->
    <v-stepper v-model="localStep" color="secondary">
      <v-stepper-header>
        <v-stepper-item
          :complete="editableSteps.assets > 0"
          :editable="editableSteps.assets > 0 && localStep !== 0"
          color="secondary"
          value="0"
          @click="goToStep('assets')"
        >
          {{ $t("labels.assets") }}
        </v-stepper-item>
        <v-divider></v-divider>

        <v-stepper-item
          :complete="editableSteps.conditions > 0"
          value="1"
          :editable="editableSteps.conditions > 0 && localStep !== 1"
          color="secondary"
          @click="goToStep('conditions')"
        >
          {{ $t("labels.conditions") }}
        </v-stepper-item>
        <v-divider></v-divider>

        <v-stepper-item
          :complete="editableSteps.actions > 0"
          value="2"
          :editable="editableSteps.actions > 0 && localStep !== 2"
          color="secondary"
          @click="goToStep('actions')"
        >
          {{ $t("labels.actions") }}
        </v-stepper-item>
        <v-divider></v-divider>

        <v-stepper-item
          :complete="editableSteps.summary > 0"
          value="3"
          :editable="editableSteps.summary > 0 && localStep !== 3"
          color="secondary"
          @click="goToStep('summary')"
        >
          {{ $t("labels.summary") }}
        </v-stepper-item>
      </v-stepper-header>
    </v-stepper>
  </v-sheet>
</template>

<script>
export default {
  props: ["step"],
  data() {
    return {
      localStep: 0,
      editableSteps: {
        assets: 0,
        conditions: 0,
        actions: 0,
        summary: 0,
      },
    };
  },
  watch: {
    step(newStep) {
      this.localStep = newStep;
    },
  },
  created() {
    this.initEditableSteps();
  },
  mounted() {
    this.localStep = this.step;
    document.addEventListener("editable-steps", (event) => {
      this.setEditableStep(event.detail.step, event.detail.value);
    });
  },
  updated() {
    this.initEditableSteps();
  },
  methods: {
    //Goes to path page
    routeTo(path) {
      this.$router.push({
        path: path,
      });
    },
    //Links Step click to relative route
    goToStep(key) {
      return this.editableSteps[key] > 0
        ? this.routeTo("/editor/" + key)
        : null;
    },

    initEditableSteps() {
      const ruleDefinition =
        JSON.parse(sessionStorage.getItem("rule")).definition || null;
      if (Object.keys(ruleDefinition)?.length !== 0) {
        const stepKeys = Object.keys(ruleDefinition);
        stepKeys.forEach((key) => {
          this.editableSteps[key] = ruleDefinition[key].length || 0;
        });
        if (Object.keys(ruleDefinition).length === 3) {
          this.editableSteps["summary"] = 1;
        }
      }
    },

    setEditableStep(step, value) {
      this.editableSteps[step] = value;
    },
  },
};
</script>
